import { Grid, Paper, styled } from '@mui/material';
import { Box } from '@mui/system';
import React, { Component } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import Constantes from '../php/Constantes';
import IngresoFuncionarios from './IngresoFuncionarios'


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    }));

class IndexConsulta extends Component {

    constructor(props){
        super(props);
        this.state = {
            fun: {
                numeroFuncionario: '',
            },
            existe: false,
            errores: null,
            datosFuncionario: {},
        }

        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
    }

    render(){
        return (
            <div>
                <form className='formulario' onSubmit={this.manejoEnvioNumeroFuncionario}>
                    <h3>Ingreso de Funcionarios</h3>
                    {
                        this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null
                    }
                        <ToastContainer></ToastContainer>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2.1}>
                                    <Item>Número de Funcionario</Item>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.numeroFuncionario} onChange={this.manejarCambiosDatos} type="number" /></Item>
                                </Grid>
                                <Grid item xs={1}>
                                    <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                </Grid>
                            </Grid>
                        </Box>
                </form>
                {this.state.existe ? <IngresoFuncionarios/> : <p></p> }
            </div>
        )
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if(!this.state.fun.numeroFuncionario.trim()){
            this.setState({
                errores: "DEBE INGRESAR UN NUMERO DE FUNCIONARIO!",
            });
        }else{
            this.setState({
                errores: null,
            })
            const cargaUtil = JSON.stringify(this.state.fun);
            const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_NumFun.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            if(exito){
                console.log(exito.length);
                if(exito.length === 0){
                    console.log('aaaa');
                    this.setState({
                        datosFuncionario: {},
                        existe: false,
                    });
                }
                exito.map((name) => {
                    if(name.primerNombre !== ''){
                        console.log('ssssa');
                        this.setState({
                            datosFuncionario: exito[0],
                            existe: true,
                        });
                    }
                });
            }
        }
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.fun;
            funcionarioActualizado[clave] = valor;
            return{
                fun: funcionarioActualizado,
            };
        })
    }
}

export default IndexConsulta